<template>
  <div :class="{'step--item':true, 'primary--left': item.position == 'left', 'primary--right': item.position != 'left'}" class="step--item" v-if="item.type=='video'" ref="root">
      <div class="item--left" v-if="item.position=='left'">
        <div class="step--content type--video" >
            <div class="background">
                <VideoBackground v-if="item.color.background" :color="item.color.background"/>
                <VideoBackground v-else/>
            </div>
            <div class="video animate-content">
                <YouTubeThumbnail :src="videoUrl(item)" :thumbnail="item.thumbnail[0].imageUrl" :autoplay="false"/>

            </div>
            <h3 class="title" v-if="item.title" v-bind:style="textColor(item)">{{ item.title }}</h3>
            <div class="content" v-html="item.content" v-bind:style="textColor(item)">

            </div>
        </div>
      </div>
      <div class="item--left" v-else>
        <div class="step--decoration type--image" v-if="item.images" ref="images">
          <div class="image--wrapper" v-for="(image,index) in item.images" :key="index">
            <img :src="imageUrl(image)"/>
          </div>
        </div>
      </div>

      <div class="item--right" v-if="item.position=='left'">
        <div class="step--decoration type--image" v-if="item.images" ref="images">
          <div class="image--wrapper" v-for="(image,index) in item.images" :key="index">
            <img :src="imageUrl(image)"/>
          </div>
        </div>
      </div>
      <div class="item--right" v-else>
        <div class="step--content type--video" >
            <div class="background">
                <VideoBackground v-if="item.color.background" :color="item.color.background"/>
                <VideoBackground v-else/>
            </div>
            <div class="video animate-content">
                <YouTubeThumbnail :src="videoUrl(item)" :thumbnail="item.thumbnail[0].imageUrl" :autoplay="false"/>

            </div>
            <h3 class="title" v-if="item.title" v-bind:style="textColor(item)">{{ item.title }}</h3>
            <div class="content" v-html="item.content" v-bind:style="textColor(item)">

            </div>
        </div>
      </div>      
  </div>
</template>

<script>
import VideoBackground from "./VideoBackground";
import YouTubeThumbnail from "./YouTubeThumbnail"
import { gsap } from "gsap";
import * as ScrollMagic from "scrollmagic";

import { developmentFixImageUrls } from '../helpers'

export default {
  name: "JourneyStep",
  components: {
    VideoBackground,
    YouTubeThumbnail
  },
  props: {
      'item': {
          type: Object,
          default: function () {
              return {}
          }
      }
  },
  data() {
    return {
        errors: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    resize() {},
    init() {
      let controller = new ScrollMagic.Controller();
      let timeline = gsap.timeline();
      let el = this.$refs.root;
      if (el) {
        timeline.from(el.querySelector('.animate-content'), {duration: 0.5, rotation:-5, scale: 0.9}, 0)
      }

      //Wait until the DOM is loaded
      this.$nextTick(() => {
        let imagesEl = this.$refs.images
        if (imagesEl) {
          let previous = null;
          let direction = imagesEl.parentNode.classList.contains('item--right') ? 'right' : 'left';
          imagesEl.children.forEach((imageEl,index) => { // eslint-disable-line no-unused-vars
            let w = previous ? previous.offsetWidth : 0;
            let h = previous ? previous.offsetHeight: 0;
            previous = imageEl;
            let distance = screen.width > 960 ? screen.width : screen.width * 0.5;
            let factor = screen.width > 960 ? 1 : screen.width/960;
            
            if (this.item.offset_x || this.item.offset_y) {
              let x = (this.item.offset_x || 0) * w * factor;
              let y = - (this.item.offset_y || 0) * h * factor;
              
              timeline.fromTo(imageEl, 0.7, {x: (direction == 'right' ? distance : -distance)}, {duration: 0.7, x: x, y: y}, 0)
            } else {
              timeline.from(imageEl, {duration: 0.7, x: (direction == 'right' ? distance : -distance)}, 0)
            }
          })
        }
      });
      
      let scene = new ScrollMagic.Scene({ // eslint-disable-line no-unused-vars
        triggerElement: el,
        duration: "25%",
        triggerHook: screen.width > 960 ? 0.5 : 0.4,
        tweenChanges: true
      })
        .setTween(timeline)
        .addTo(controller);
    },
    textColor(item) {
      return {color: (item.color?.foreground ? item.color.foreground : '#000')}
    },
    videoUrl(item) {

      return `https://www.youtube.com/embed/${item.videoId}?autoplay=1`
    },
    imageUrl(image) {
      //Only in development
      if (process.env.NODE_ENV == 'development') {
        return developmentFixImageUrls(image.imageUrl);
      }
      return image.imageUrl;
    }
  },
  computed: {
  }
};
</script>

<style>
.multiselect__tag {
  background-color: #30b5e4;
  color: #0b1f3e;
}
</style>

<style scoped lang="scss">
.step--item {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    margin-bottom: 150px;
}
.item--left {
    width: 50%;
}
.item--right {
    width: 50%;
    display: flex;
    padding-left: 5%;
}
.step--content {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    padding: 0px 10% 25px 25px;
    &.type--video {
        .background {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
        }
        .video {
            position: relative;
            flex: 0 0 90%;
            width: 100%;
            margin-left: -30px;
            margin-top: -50px;
            margin-bottom: 20px;
        }
        img {
            width: 100%;
        }
        .content, .title {
          position: relative;
          width: 100%;
          flex: 0 0 100%;
          margin: 0 0 10px 0;
          box-sizing: border-box;
        }
    }
}
.step--decoration {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  max-width: 500px;
  .image--wrapper {
    position: absolute;
    width: 50%;
    top: 50%;
    transform: translateY(-50%);
    img {
      width: 100%;
    }
  }
}
.content, .title {
  text-align: left;
  padding-left: 15%;
}
@media (max-width: 480px) {
  .primary--left {
    .item--left {
      width: 70%;
    }
    .item--right {
      width: 30%;
      padding-left: 10px;
    }
  }
  .primary--right {
    .item--left {
      width: 30%;
      padding-right: 10px;
    }
    .item--right {
      width: 70%;
      padding: 0;
    }
  }
  .image--wrapper {
    img {
      transform: scale(1.5);
    }
  }
  h3.title {
    font-size: 0.9em;
  }
  .step--content.type--video {
    .video {
      flex: 0 0 100%;
    }
  }
}
</style>